import { Reducer } from "@reduxjs/toolkit";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState, createForeignKeySelector } from "../../../Store/Thunks/asyncEntityStateUtil";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { fetchStationConsumptionByStationIdsThunk } from "../../../Store/Thunks/stationStatusByIds";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";
import { StationConsumptions } from "./queryStationStatus";

// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice({
  name: "stationConsumption",
  reducers: {
    },
  fetchByIdsThunk: fetchStationConsumptionByStationIdsThunk,
  selectId:(stationConsumption) => stationConsumption.target_id
})

export const stationConsumptionReducer = reducer as Reducer<AsyncEntityState<StationConsumptions, number>>;

const selectState = (state: RootState) => state.graphQlData.stationConsumption;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectStationConsumptionsById, selectAll: SelectAllStationConsumptions} = entityAdapter.getSelectors(selectState);

const stationConsumptionByIdFetcher = new EnqueueFetcher(fetchStationConsumptionByStationIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const upsertStationConsumption = upsertMany;

export const dispatchFetchStationConsumptionById = stationConsumptionByIdFetcher.enqueueFetchById;

export const {selectEntitiesByForeignKey: selectStationConsumptionByStationId} = createForeignKeySelector<StationConsumptions, number, AsyncEntityState<StationConsumptions, number>, number>((state) => state.graphQlData.stationConsumption, "target_id");
const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

export const useStationConsumptionById = entityByIdWithStatusHookFactory<StationConsumptions, number>(stationConsumptionByIdFetcher.enqueueFetchById, selectStationConsumptionsById, selectLoadingIds)

